import React, { ReactNode } from 'react';
import Typography from '@lib/components/Typography/Typography';
import styles from '../SelectPanel.module.scss';

type SelectPanelStatesProps = {
  title?: ReactNode;
  fallbackTitle?: string;
};

export function SelectPanelStates(props: SelectPanelStatesProps) {
  const { title, fallbackTitle } = props;
  return (
    <div className={styles.states}>
      <Typography variant="caption">{title ?? fallbackTitle ?? ''}</Typography>
    </div>
  );
}
